import { Flex, Text, Heading, HStack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

import { Button } from "./ui/button";

import GroupImage3 from "../assets/images/groupImage3.png";

export const GetStarted = () => {
  const navigate = useNavigate();

  return (
    <Flex
      h={{ base: "300px", md: "100vh" }}
      backgroundSize={"cover"}
      backgroundPosition={"center"}
      bgRepeat={"no-repeat"}
      px={{ base: "35px", md: "26px" }}
      py={{ base: "50px", md: "43px" }}
      align={"center"}
      justify={"center"}
      backgroundImage={`url(${GroupImage3})`}
      position="relative"
      _before={{
        content: '""',
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: "#0C1D18",
        opacity: 0.5,
        zIndex: 0,
      }}
    >
      <Flex
        position="relative"
        zIndex={1}
        flexDir={"column"}
        align={"center"}
        w={{ base: "100%", md: "40%" }}
      >
        <Heading
          fontSize={{ base: "23px", md: "60px" }}
          fontWeight={500}
          color={"white"}
          lineHeight={"140%"}
          textAlign={"center"}
          fontFamily={"DMSans-Medium"}
        >
          Get Started on Your Success Journey
        </Heading>

        <Text
          fontSize={{ base: "14px", md: "20px" }}
          color={"#EBF0F0"}
          textAlign={"center"}
          mt="8px"
          fontFamily={"Sora-Regular"}
        >
          Take the first step toward achieving your goals with expert guidance
          and strategic solutions.
        </Text>

        <HStack gap={"17px"} mt="24px">
          <Button opaque={false} onClick={() => navigate("/contact")}>
            Get Started
          </Button>

          <Button>About Us</Button>
        </HStack>
      </Flex>
    </Flex>
  );
};
